import { render, staticRenderFns } from "./IdentifyInfo.vue?vue&type=template&id=7fa5706e&scoped=true&"
import script from "./IdentifyInfo.vue?vue&type=script&lang=ts&"
export * from "./IdentifyInfo.vue?vue&type=script&lang=ts&"
import style0 from "./IdentifyInfo.vue?vue&type=style&index=0&id=7fa5706e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa5706e",
  null
  
)

export default component.exports